// import { fetchMethod } from "../../FetchMethod";
import React from "react";
// import { siteStateData, siteCityData } from "./SiteQuery";
export const sitesList = {
  showPagination: true,
  columns: [
    { Header: "Site Name", accessor: "name", sortable: false },
    { Header: "Location", accessor: "location", sortable: false },
    {
      Header: "Physicians",
      accessor: "physicians",
      sortable: false,
      Cell: (row) => {
        return row.original.physiciancount > 0 ? (
          <div>
            {row.original.physician}{" "}
            {!row.original.physicianclicked ? (
              <a
                onClick={(e) => row.original.LinkClicked(e, row.original)}
                id="physicians"
              >
                + {row.original.physiciancount} more
              </a>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>{row.original.physician}</div>
        );
      },
    },
    {
      Header: "Assistants",
      accessor: "assistance",
      sortable: false,
      Cell: (row) => {
        return row.original.assistantcount > 0 ? (
          <div>
            {row.original.assistance}{" "}
            {!row.original.assistantclicked ? (
              <a
                onClick={(e) => row.original.LinkClicked(e, row.original)}
                id="assistance"
              >
                + {row.original.assistantcount} more
              </a>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>{row.original.assistance}</div>
        );
      },
    },
    {
      Header: "Sales Rep",
      accessor: "salesRep",
      sortable: false,
      Cell: (row) => {
        return row.original.salesrepcount > 0 ? (
          <div>
            {row.original.salesRep}{" "}
            {!row.original.salesrepclicked ? (
              <a
                onClick={(e) => row.original.LinkClicked(e, row.original)}
                id="salesRep"
              >
                + {row.original.salesrepcount} more
              </a>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>{row.original.salesRep}</div>
        );
      },
    },
    {
      Header: "Status",
      accessor: "approvalstatus",
      Cell: (row) =>
        row.original.approvalstatus === "PENDINGCONDITIONALAPPROVED" ? (
          <div style={{ color: "#F10000" }}>Pending Conditional Approval</div>
        ) : row.original.approvalstatus === "CONDITIONALLYAPPROVED" ? (
          <div style={{ color: "#F9AD17" }}>Conditionally Approved</div>
        ) : row.original.approvalstatus === "APPROVEDTOTREAT" ? (
          <div style={{ color: "#096738" }}>Approved to Treat</div>
        ) : (
          <div style={{ color: "#0071CE" }}>Independent</div>
        ),
      sortable: false,
      width: 200,
    },
  ],
};

export const addSite = {
  className: "AddSite",
  fields: [
    {
      type: "input",
      name: "siteid",
      label: "Site ID",
      value: "",
      required: true,
      maxLength: 2,
    },
    {
      type: "input",
      name: "name",
      label: "Site Name",
      value: "",
      required: true,
    },
    {
      type: "heading",
      label: "Address",
    },
    {
      type: "searchSelect",
      name: "countryid",
      label: "Country",
      value: null,
      data: "countryOptions",
      independentSearch: "siteconfig",
    },
    {
      type: "searchSelect",
      name: "stateid",
      label: "State/Province",
      value: null,
      data: "stateOptions",
      dependentSearch: "statedata",
      parent: "countryid",
    },
    {
      type: "searchSelect",
      name: "cityid",
      label: "City",
      value: null,
      data: "cityOptions",
      dependentSearch: "citydata",
      parent: "stateid",
    },
    {
      type: "textarea",
      name: "address1",
      label: "Address Line 1",
      value: "",
    },
    {
      type: "textarea",
      name: "address2",
      label: "Address Line 2",
      value: "",
    },
    {
      type: "input",
      name: "zipcode",
      label: "Zip Code",
      value: "",
      maxLength: 10,
    },
    {
      type: "heading",
      label: "Site Approval",
    },
    {
      type: "radio",
      name: "approvalstatus",
      value: "PENDINGCONDITIONALAPPROVED",
      options: [
        {
          name: "Pending Conditional Approval",
          value: "PENDINGCONDITIONALAPPROVED",
        },
        { name: "Conditionally Approved", value: "CONDITIONALLYAPPROVED" },
        { name: "Approved to Treat", value: "APPROVEDTOTREAT" },
        { name: "Independent", value: "INDEPENDENT" },
      ],
    },
    {
      type: "content",
      name: "Email",
    },
  ],
  dependency: [
    {
      parent: "countryid",
      child: "stateid",
      childOptions: "stateOptions",

      listingFunction: (value) => {
        if (value === null) {
          return [];
        }
      },
    },
    {
      parent: "stateid",
      child: "cityid",
      childOptions: "cityOptions",

      listingFunction: (value) => {
        if (value === null) {
          return [];
        }
      },
    },
  ],
  validations: {
    siteid: (e) => {
      if (e === "") {
        return {
          valid: false,
          errMsg: "Site ID is mandatory.",
        };
      }
      if (e.length !== 2) {
        return {
          valid: false,
          errMsg: "Site ID must have two characters. ",
        };
      }
      return {
        valid: true,
      };
    },
    name: (e) => {
      if (e === "") {
        return {
          valid: false,
          errMsg: "Site Name is mandatory.",
        };
      }
      return {
        valid: true,
      };
    },
    zipcode: (e) => {
      if (e === "" || e === null) {
        return { valid: true };
      }
      // if (e.length > 10) {
      //   return {
      //     valid: false,
      //     errMsg: "zipcode length should be less than 10",
      //   };
      // }

      return {
        valid: true,
      };
    },
  },
};
